import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import SectionWithToolbar from 'components/SectionWithToolbar';
import RoomRatesTable from 'components/RoomRatesTable';
import RoomRatesToolbar from 'components/RoomRatesToolbar';
import RoomRatesEditor from 'components/RoomRatesEditor';
import RoomRatesEditorInit from 'components/RoomRatesEditorInit';

import { PackageEditAccomodationPrices_package$key } from '__generated__/PackageEditAccomodationPrices_package.graphql';
import { PackageEditAccomodationPrices_data$key } from '__generated__/PackageEditAccomodationPrices_data.graphql';

type Props = {
  package: PackageEditAccomodationPrices_package$key;
  data: PackageEditAccomodationPrices_data$key;
};

const PackageEditAccomodationPrices: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment PackageEditAccomodationPrices_package on Package {
        cateringOptions {
          id
        }

        rooms {
          id
        }

        ...RoomRatesTable_package
        ...RoomRatesEditorInit_package
        ...RoomRatesToolbar_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageEditAccomodationPrices_data on Query {
        ...RoomRatesTable_data
        ...RoomRatesToolbar_data
        ...RoomRatesEditorInit_data
      }
    `,
    props.data
  );

  const { cateringOptions, rooms } = pack;

  return (
    <RoomRatesEditor>
      <SectionWithToolbar
        title="Kambarių kainos"
        id="prices"
        toolbar={<RoomRatesToolbar package={pack} data={data} />}>
        {cateringOptions.length > 0 && rooms.length > 0 ? (
          <RoomRatesTable package={pack} data={data} />
        ) : (
          <RoomRatesEditorInit package={pack} data={data} />
        )}
      </SectionWithToolbar>
    </RoomRatesEditor>
  );
};

export default PackageEditAccomodationPrices;
